<template>
  <div class="app" id="app" :data-theme="theme">
    <transition name="fade">
      <c-loader v-if="loading" :size="99" />
    </transition>

    <router-view v-if="!loading" v-slot="{ Component }">
      <component :is="Component" />
    </router-view>

    <c-feedbacks
      :feedbacks="$feedback.list"
      @close="feedback => $feedback.remove(feedback)"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import CLoader from '@convenia/components/CLoader'
import CFeedbacks from '@convenia/components/CFeedbacks'
import * as types from '@types'
import * as middlewareRequests from '@graphql/middleware'
import useMediaQueryRoot from '@convenia/composables/useMediaQueryRoot'

useMediaQueryRoot()

const { proxy } = getCurrentInstance()
const theme = import.meta.env.VITE_THEME || 'default'
const loading = ref(true)

const init = async () => {
  const [ err, token ] = await proxy.$store.dispatch(types.AUTH_AUTHENTICATE)

  if (!err && token) middlewareRequests.setToken(token)
  loading.value = false
}

onMounted(init)
</script>

<script>
export default {
  name: 'AdmissionApp',
  compatConfig: { MODE: 3, INSTANCE_EVENT_EMITTER: true }
}
</script>

<style lang="scss">
.app {
  height: 100%;
  display: flex;
  flex-flow: column;
  background: #F3F4F6;

  & > .c-loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    @include media-until(1023px) {
      width: 79px !important;
      height: 79px !important;
    }
  }

  @include media-until(1023px) {
    & > .coe-feedbacks {
      top: 10px !important;
    }
  }

  @include responsive (tablet, desktop) {
    & > .coe-feedbacks {
      bottom: 100px !important;
    }
  }
}

// Transitions
.view-enter-active, .view-leave-active {
  transition: opacity .3s, transform .3s;
}
.view-enter-from, .view-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

.stamp-enter-active, .stamp-leave-active {
  transition: opacity .3s, transform .3s;
}
.stamp-enter-from, .stamp-leave-to {
  opacity: 0;
  transform: scale(1.5);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

// Animations
@keyframes shake {
  10%, 90% { transform: translate(-1px, 0); }
  20%, 80% { transform: translate(2px, 0); }
  30%, 50%, 70% { transform: translate(-4px, 0); }
  40%, 60% { transform: translate(4px, 0); }
}

// SHAME Overrides
.c-button {
  &.-disabled:not(.-flat) {
    background: white;
    &:before {
      width: 100%;
      transform: translate3d(-50%, -30%, 1px);
      background: #121E48;
      opacity: .05;
      transition: none;
    }
    & > .text { color: rgba(#121E48, .3); }
    &:after {
      background: rgba(#121E48, .13);
      opacity: 1;
    }
  }
}
</style>

<style src="./styles/index" lang="scss" />
